/**
 * This file is for "dependencies" that are more complex than the abstract
 * system can handle, e.g. when Add SEMS is toggled, we need to enable the
 * dependent fields (handled by the regular system) AND add a specific operation
 * if it is not already present
 */

import { ApplicationError } from '@errors/application/application-error';
import { objectValuesTyped } from '@snap-types/util/object-iterators';
import { createBlueprintAndFieldsFromStep } from '@ui/features/configurator/store/helpers/blueprint-helpers';
import type {
  ConfiguratorFieldType,
  ConfiguratorStoreState,
} from '@ui/features/configurator/types';
import invariant from 'tiny-invariant';

export function checkSpecialFieldDependencies(
  field: ConfiguratorFieldType,
  state: ConfiguratorStoreState,
) {
  switch (field.fieldId) {
    case 'add_sems':
      invariant(typeof field.value == 'boolean', 'add_sems must be a boolean');
      checkSpecialAddSemsDependencies(field.value, state);
      break;
  }
}

function checkSpecialAddSemsDependencies(
  value: boolean,
  state: ConfiguratorStoreState,
) {
  if (!value) {
    // We only ADD rolling if we are ADDING SEMS; if SEMS is being
    // removed, we don't touch the existing Rolling step
    return;
  }

  const hasRollingOperation = state.blueprint.operations.some(
    (operation) =>
      operation.operationType === 'internal' &&
      operation.stepKey === 'rolling_threading',
  );

  if (hasRollingOperation) {
    return;
  }

  const rollingOperation = objectValuesTyped(state.configuration.steps).find(
    (step) => step.step_key === 'rolling_threading',
  );

  if (!rollingOperation) {
    throw new ApplicationError(
      'Rolling/Threading step not found in configuration',
    );
  }

  createBlueprintAndFieldsFromStep(
    rollingOperation,
    state.configuration,
    state.blueprint,
    state.fields,
  );
}
